module.exports = __webpack_public_path__ + "img/Mayor Josh Morgan Graphic.48d4ad58.png";